import { getKeyBySelector } from '@vista/omnichannel-components-domain';
export const getGroupedLines = (lines, keySelector) => {
    const groupMap = lines.reduce((acc, line) => {
        const key = getKeyBySelector(line, keySelector);
        const existingGroup = acc[key];
        if (!existingGroup)
            acc[key] = { key, line, quantity: 1 };
        else
            existingGroup.quantity++;
        return acc;
    }, {});
    return Object.values(groupMap);
};
